__turbopack_context__.v({
  "ThreeD": "threeD-module-scss-module__vgnohG__ThreeD",
  "ThreeD__slide": "threeD-module-scss-module__vgnohG__ThreeD__slide",
  "ThreeDimg": "threeD-module-scss-module__vgnohG__ThreeDimg",
  "centerSlide": "threeD-module-scss-module__vgnohG__centerSlide",
  "hiddenSlide": "threeD-module-scss-module__vgnohG__hiddenSlide",
  "leftSlide": "threeD-module-scss-module__vgnohG__leftSlide",
  "rightSlide": "threeD-module-scss-module__vgnohG__rightSlide",
});
